import React from "react";
import "./ServicePages.scss";

//Panels
import Hero from "./Components/Hero";

//Images
import pooldecks from "./images/pooldecks/bg-pooldecks.jpg";
import featureA1 from "./images/pooldecks/feature-a-1.jpg";
import featureA2 from "./images/pooldecks/feature-a-2.jpg";
import featureA3 from "./images/pooldecks/feature-a-3.jpg";
import featureB1 from "./images/pooldecks/feature-b-1.jpg";
import featureB2 from "./images/pooldecks/feature-b-2.jpg";
import featureB3 from "./images/pooldecks/feature-b-3.jpg";
import featureC1 from "./images/pooldecks/Pavilion-I-II-Dark-Gray-Pewter-Charcoal.jpg";
import featureC2 from "./images/pooldecks/Belgard_LafittGranaSlab_TITANIUM.jpg";
import featureC3 from "./images/pooldecks/BEL2018_Coastal_Swatch_Mega_Arbel_Amaretto.jpg";

//SEO
import SEO from "../../../SEO/index.js";
import StructuredData from "../../../SEO/structuredData";

const PoolDecks = () => {
  return (
    <>
      <SEO
        title="Pool Deck Paver | Travertine & Flagstone | Pacific Pavingstone"
        description="In the scorching summer heat of Southern California, the backyard pool has become an inviting and uniting oasis. Start renovating your pool patio today!"
        profileURL={"https://www.pacificpavingstone.com/services/pool-decks"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "Service",
          name: "Pool Deck Paver",
          image:
            "https://www.pacificpavingstone.com/static/media/bg-pooldecks.86e53702.jpg",
          description:
            "In the scorching summer heat of Southern California, the backyard pool has become an inviting and uniting oasis. Start renovating your pool patio today!",
          brand: "Pacific Pavingstone",
          areaServed: "Southern California",
          logo: "https://www.pacificpavingstone.com/static/media/logo-2.bf1f43f9.png",
          provider: "Pacific Pavingstone",
          URL: "https://www.pacificpavingstone.com/services/pool-decks",
          potentialAction: "Schedule a Consultation",
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5",
            bestRating: "5",
            worstRating: "1",
            ratingCount: "1",
            reviewCount: "1",
          },
          review: {
            "@type": "Review",
            name: "R.G.",
            reviewBody:
              "We hired Pacific Pavingstone to replace our concrete driveway and pool deck with paving stones. From the initial consultation, through the multifaceted installation process, and completion, they were top notch- professional, courteous, and responsive. At one point there were some issues with sealing our pool coping, but they took the time to find anappropriate solution with a perfect outcome.",
            reviewRating: {
              "@type": "Rating",
              ratingValue: "5",
              bestRating: "5",
              worstRating: "1",
            },
            datePublished: "2021-10-08",
            author: { "@type": "Person", name: "R.G." },
            publisher: { "@type": "Organization", name: "Pacific Pavingstone" },
          },
        }}
      />
      <div className="container-fluid page-featured">
        <Hero title={"Pool Decks"} background={pooldecks} />
        <div className="row justify-content-center">
          <div className="col-11 col-md-9">
            <div className="row justify-content-center panel-content pb-4">
              <div className="col-12">
                <p>
                  In the scorching summer heat of Southern California, the
                  backyard pool has become an inviting and uniting oasis.
                  Renovating an old pool patio or choosing the best pool paving
                  materials to surround it, is one of the most crucial pool
                  design decisions. Even if your kids are fish and rarely come
                  out of the water, the surrounding surface will get as much, if
                  not more use than the pool itself.
                  <br />
                  <br />
                  Choosing the best pool paving materials is a pursuit that can
                  become complicated. Materials, colors, textures, and designs
                  seem to present countless options. However, with a little
                  guidance, you can quickly be traveling down the cool and
                  exciting path that leads to the pool area of your dreams.
                </p>
              </div>
            </div>
            <div className="row justify-content-center panel-content pb-4">
              <div className="col-12">
                <h3>
                  Considering the Best Pool Paving Material Options for Southern
                  California
                </h3>
                <p>
                  When you consult with a{" "}
                  <a
                    href="https://www.pacificoutdoorliving.com/services/pools/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    pool company in Los Angeles
                  </a>{" "}
                  or the surrounding areas, the actual pool is only one of the
                  parts that drive the cost of the overall plan. However, if a
                  poor pool paving material choice is made, it can mean the di
                  ff erence of loving or hating the time you spend in the
                  backyard. Regardless of the materials you choose, there are 4
                  main requirements for pool paving materials:
                </p>
                <h3 className="mt-5">
                  4 Main Requirements for Pool Paving Materials
                </h3>
                <ol>
                  <li>
                    Pool patios need to reflect heat so they’re tolerable to
                    walk on barefooted.
                  </li>
                  <li>
                    Pool patios need to be safe, so smooth textures should be
                    avoided.
                  </li>
                  <li>
                    Pool patios need to allow surface water to drain so the
                    surface will dry quickly.
                  </li>
                  <li>Pool patios need to require very little maintenance.</li>
                </ol>
                <p>
                  In order to help you make sure that the best pool paving
                  materials for your project, here is a round-up of some of the
                  common choices for pool deck materials:
                </p>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12">
                <h2 className="text-center text-uppercase mb-4">
                  Paver Patios Around Pools
                </h2>
                <p>
                  Interlocking pavers come in a wide variety of colors, sizes,
                  and textures. Combine the design versatility of borders,
                  unique patterns, and the mixing of materials, and pavers
                  (paving stones) have become an extremely popular choice among
                  the best pool paving materials you can find.
                  <br />
                  <br />
                  Paving stone manufacturers frequently come out with new
                  products that expand options in both contemporary and
                  old-world styles. Pavers are a unique form of manufactured
                  concrete, superior traditional concrete. Each year some
                  cutting edge product is introduced, with one of the latest
                  paving stone innovations of outdoor porcelain tiles. We expect
                  that product to continue to increase in its popularity.
                  <br />
                  <br />
                  Some of the best paving around pools you will find in the Los
                  Angeles area is made from pavers. When these surfaces use
                  polymeric sand between stones, the joints lock together and
                  drain much more quickly than poured concrete patios. Many
                  styles of pavers offer the safest surfaces to prevent slips
                  around pools.
                </p>
              </div>
              <div className="col-12 mt-5">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA1}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA2}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA3}
                      alt="Featured"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12">
                <h2 className="text-center text-uppercase mb-4">
                  Pool Patios Made from Natural Stone
                </h2>
                <p>
                  Another elegant choice and one of the best pool paving
                  materials for your Southern California backyard oasis are
                  natural stone options. Natural stone materials we commonly use
                  on pool design projects are flagstone and travertine.
                  <br />
                  <br />
                  Rectangular and square pieces of cut flagstone and travertine
                  are fitted together much like that of paving stone
                  installations. Laid upon a base of sand, these patios offer a
                  firm surface that won’t crack like concrete applications. The
                  joints in between natural stones are filled with polymeric
                  sand which hardens the first time it is wetted.
                  <br />
                  <br />
                  Lighter color blends of travertine patios around pools provide
                  a cool surface to walk upon, whereas flagstone can become
                  slightly hot if a dark color is chosen. Both of these surfaces
                  are slightly more smooth than a paver patio, but certainly not
                  as slippery as some finished, glazed poured concrete.
                </p>
              </div>
              <div className="col-12 mt-5">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB1}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB2}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB3}
                      alt="Featured"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center panel-content pb-4">
              <div className="col-12">
                <h3>
                  Creating a beautiful pool and surrounding patio is only part
                  of the equation. Some of these considerations can include:
                </h3>
                <ol>
                  <li>Drainage solutions</li>
                  <li>
                    Plants that don’t make a mess in your pool or encroach on
                    guests or surfaces
                  </li>
                  <li>Strategically-placed shade trees</li>
                  <li>Hedges or structures for privacy screening</li>
                  <li>Options for low-maintenance, less-mess turf areas</li>
                  <li>
                    Additions such as cabanas, changing rooms, outdoor kitchens
                  </li>
                  <li>
                    Landscape Lighting for increased safety and nighttime
                    functionality
                  </li>
                </ol>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12 mt-4">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style mb-2 mb-lg-0">
                      <img
                        src={featureC1}
                        alt="Angelus Pavilion I&II shown in Dark Gray Pewter"
                      />
                      <div className="text">
                        <p>
                          Angelus Pavilion I&II shown
                          <br />
                          In Dark Gray Pewter
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style mb-2 mb-lg-0">
                      <img
                        src={featureC2}
                        alt="Belgard Lafitt Grana Slab in Titanium"
                      />
                      <div className="text">
                        <p>
                          Belgard Lafitt Grana Slab
                          <br />
                          In Titanium
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style mb-2 mb-lg-0">
                      <img
                        src={featureC3}
                        alt="Belgard Mega-Arbel in Amaretto"
                      />
                      <div className="text">
                        <p>
                          Belgard Mega-Arbel
                          <br />
                          In Amaretto
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PoolDecks;
